const state = () => ({
  defensiveShape: {
    useOffsideTrap: 0,
    engagementLine: 0,
    defensiveLine: 0,
    defensiveWidth: 0,
  },

  markingAndTackling: {
    useTighterMarking: false,
    pressingUrgency: 0,
    preventGKDistribution: false,
    tackling: 0,
  },

  pressingTrap: 0,
  crossEngagement: 0,
});

const mutations = {
  updateOffsideTrap (state, value) {
    state.defensiveShape.useOffsideTrap = value;
  },
  updateEngagementLine (state, value) {
    state.defensiveShape.engagementLine = value;
  },
  updateDefensiveLine (state, value) {
    state.defensiveShape.defensiveLine = value;
  },
  updateDefensiveWidth (state, value) {
    state.defensiveShape.defensiveWidth = value;
  },

  updateTighterMarking (state, value) {
    state.markingAndTackling.useTighterMarking = value;
  },
  updatePressingUrgency (state, value) {
    state.markingAndTackling.pressingUrgency = value;
  },
  updatePreventGKDistribution (state, value) {
    state.markingAndTackling.preventGKDistribution = value;
  },
  updateTackling (state, value) {
    state.markingAndTackling.tackling = value;
  },

  updatePressingTrap (state, value) {
    state.pressingTrap = value;
  },

  updateCrossEngagement (state, value) {
    state.crossEngagement = value;
  },

};

export default {
  state,
  mutations
};
